module.exports = function() {
  return new Worker("/" + "stylus-transpiler.b65928e6.worker.js");
};